import { dev } from '$app/environment';

export const PRODUCTION_HOSTNAME_REGEX = /(https?:\/\/)?(?:www\.)?casumo\.(?:com|es)/;
export const TEST_HOSTNAME_REGEX = /(https?:\/\/)?(?:www\.)?casumotest\.(?:com|es)/;

export const isNativeAppRequest = (headers: Headers) => {
    const userAgent = headers.get('user-agent') || '';
    return userAgent.includes('casumo');
};
export const isOfficeRequest = (headers: Headers) => {
    return headers.get('X-Is-Office-Request') === 'true';
};
// Please only use the exported "isTest" function below to also account for localhost development
const isCasumoTestRequest = (hostname: string) => {
    return TEST_HOSTNAME_REGEX.test(hostname);
};
export const isCasumoProdRequest = (hostname: string) => {
    return PRODUCTION_HOSTNAME_REGEX.test(hostname);
};

export const isTest = (hostname: string) => isCasumoTestRequest(hostname) || dev;

export const getEnvironmentHost = (hostname: string) => {
    if (isTest(hostname)) {
        return 'https://www.casumotest.com';
    }
    return 'https://www.casumo.com';
};
